<!--Scroll to top-->
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button type="button" mat-icon-button class="hidden-print" (click)="scrollToTop()">
    <mat-icon>arrow_upward</mat-icon>
  </button>

</div>